export function getListingMMT(make: { name?: any } | null | undefined, model: { name?: any } | null | undefined, trim: { name?: any } | null | undefined): string {

    // Validate input values
    const makeName = make?.name?.trim() ?? '';
    const modelName = model?.name?.trim() ?? '';
    const trimName = trim?.name?.trim() ?? '';
  
    // Concat string after validation
    const listingMMT = [makeName, modelName, trimName].filter(String).join(' ');
    return listingMMT;
  }
